import { render, staticRenderFns } from "./ResellerList.vue?vue&type=template&id=8182b506&scoped=true&"
import script from "./ResellerList.vue?vue&type=script&lang=js&"
export * from "./ResellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8182b506",
  null
  
)

export default component.exports